import styled, { css } from 'styled-components';

export const AxisLabelsContainer = styled.div`
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    pointer-events: none;
    z-index: 3;
`;

const axisLabelBase = css`
    position: absolute;
    font-size: 14px;
    font-weight: 700;
    color: #2773BE;
    display: flex;
    align-items: center;
    justify-content: center;

    @media (max-width: 800px) {
        font-size: 11px;
    }

    @media (max-height: 550px) {
        font-size: 10px;
    }
`;

export const XLabel = styled.div`
    ${axisLabelBase}
    top: 50%;
    left: ${({ $left }) => $left}%;
    transform: translate(-50%, 2px);
    padding-top: 2px;
`;

export const YLabel = styled.div`
    ${axisLabelBase}
    left: 50%;
    top: ${({ $top }) => $top}%;
    transform: translate(4px, -50%);
    padding-left: 2px;
`;

export const XAxisArrow = styled.div`
    position: absolute;
    top: 50%;
    right: -2px;
    transform: translateY(-50%);
    width: 0;
    height: 0;
    border-top: 8px solid transparent;
    border-bottom: 8px solid transparent;
    border-left: 12px solid #2773BE;

    @media (max-width: 800px) {
        border-top-width: 6px;
        border-bottom-width: 6px;
        border-left-width: 9px;
    }
`;

export const YAxisArrow = styled.div`
    position: absolute;
    left: 50%;
    top: -2px;
    transform: translateX(-50%);
    width: 0;
    height: 0;
    border-left: 8px solid transparent;
    border-right: 8px solid transparent;
    border-bottom: 12px solid #2773BE;

    @media (max-width: 800px) {
        border-left-width: 6px;
        border-right-width: 6px;
        border-bottom-width: 9px;
    }
`;

export const AxisLetter = styled.div`
    position: absolute;
    font-size: 18px;
    font-weight: 800;
    color: #2773BE;

    ${({ $axis }) => $axis === 'x' && css`
        top: 50%;
        right: -20px;
        transform: translateY(-50%);
    `}

    ${({ $axis }) => $axis === 'y' && css`
        left: 50%;
        top: -22px;
        transform: translateX(8px);
    `}

    @media (max-width: 800px) {
        font-size: 14px;

        ${({ $axis }) => $axis === 'x' && css`
            right: -16px;
        `}

        ${({ $axis }) => $axis === 'y' && css`
            top: -18px;
        `}
    }
`;
